import dayjs from '../services/dayjs';

export const formatWaitTime = (date: string | Date | undefined): string => {
  if (!date) return '';

  const now = dayjs();
  const start = dayjs(date);
  const diffInMs = Math.max(0, now.diff(start));
  const d = dayjs.duration(diffInMs);

  // Calcula o total de dias, permitindo que ultrapasse 30 (sem converter para meses)
  const days = Math.floor(d.asDays());
  if (days >= 1) {
    return `há ${days} ${days === 1 ? 'dia' : 'dias'}`;
  }

  // Se for menos de um dia, exibe total de horas
  const hours = Math.floor(d.asHours());
  if (hours >= 1) {
    return `há ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
  }

  // Se for menos de uma hora, exibe total de minutos
  const minutes = Math.floor(d.asMinutes());
  if (minutes >= 1) {
    return `há ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
  }

  // Caso padrão para menos de um minuto
  return 'há poucos segundos';
};
